import { BellIcon, SearchIcon, TriangleUpIcon } from '@chakra-ui/icons';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  IconButton,
  Tooltip,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Stack,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  ModalContent,
  Modal,
  useColorMode,
  useToast,
  VisuallyHidden,
} from '@chakra-ui/react';
import { navigate, useLocation } from '@reach/router';
import { Auth, graphqlOperation } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { ImUser, ImUserTie } from 'react-icons/im';
import { IoMdUnlock } from 'react-icons/io';
import { MdSettings, MdDelete } from 'react-icons/md';
import { RiLogoutBoxRFill } from 'react-icons/ri';
import { connect } from 'react-redux';
import {
  isDeliveryPauseOrder,
  isPickupPauseOrder,
  isShippingPauseOrder,
  deleteMerchantUserProfile,
} from '../../../graphql/mutations';
import { listOrderShipments } from '../../../graphql/queries';
import { graphql } from '../../../utils/api';
import { logout } from '../../../utils/auth';
import { menuListStylesProps } from '../../../utils/stylesProps';
import ChangePasswordView from '../../auth/change-password';
import MobileSidebar from '../mobile-sidebar';
import PausedStoresInfoModal from '../paused-stores-info-modal';

function TopbarWithoutRedux({
  pageName,
  user,
  userName,
  profileImage,
  serviceableStores,
  updateServiceableStores,
  accessModules,
}) {
  const toast = useToast();
  const { colorMode, toggleColorMode } = useColorMode();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const storesNotServiceable = serviceableStores?.items?.filter(
    (st) => st.isDeliveryPaused || st.isPickupPaused === true,
  );
  const customActions = accessModules?.find(
    (a) => a.module === 'custom-actions',
  );

  const changePasswordConfirmOpenFunc = (bool) => {
    setChangePasswordOpen(bool);
  };

  const onChangePasswordClose = () => {
    setChangePasswordOpen(false);
  };

  const updateStore = async (updateStoreObj) => {
    try {
      const res = await graphql(
        graphqlOperation(isDeliveryPauseOrder, {
          input: updateStoreObj,
        }),
      );
      if (res?.data?.updateStore?.isDeliveryPaused) {
        toast({
          title: 'Success',
          description: 'Successfully paused the delivery orders',
        });
      } else {
        toast({
          title: 'Success',
          description: 'Successfully resumed the orders',
        });
      }

      if (res?.data) {
        updateServiceableStores();
      }
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Something went wrong',
        status: 'error',
        isClosable: true,
        duration: 5000,
      });
    }
  };
  // const signout = async () => {
  //   signOut();
  //   navigate('/');
  //   setConfirmOpen(false);
  // };

  const deleteUser = async () => {
    console.log('user212', user);
    const graphqlQuery = graphqlOperation(deleteMerchantUserProfile, {
      input: {
        userId: user?.userId,
        userRole: user?.userRole,
        merchantAccountId: user?.merchantAccount?.id,
      },
    });
    const res = await graphql(graphqlQuery);
    if (res.data.deleteMerchantUserProfile) {
      await Auth.signOut();
      logout(() => {
        navigate('/login');
      });
    }
  };
  let shipmentItems = [];
  const handleDeleteAccount = async () => {
    const assignedStores = [];
    const stores = serviceableStores?.items;
    if (stores?.length > 0) {
      stores.forEach((store) => {
        assignedStores.push({ assignedStoreId: { eq: store.id } });
      });
    }
    console.log('shipmentItems', assignedStores, serviceableStores);
    const filterStatus = [
      'Placed',
      'Accepted',
      'ShelfToCounter',
      'Dispatched',
      'Shipped',
      'Billed',
      'Packing',
    ];
    const shipmentItems = [];
    filterStatus.forEach((shipment) => {
      shipmentItems.push({ shipmentStatus: { eq: shipment } });
    });
    const filterItems = { or: assignedStores, and: { or: shipmentItems } };
    if (stores.length > 0) {
      const graphqlQuery = await graphqlOperation(listOrderShipments, {
        filter: filterItems,
      });
      const results = await graphql(graphqlQuery);
      console.log('graphqlQuery', results.data.listOrderShipments.items.length);
      if (
        user.userRole === 'Merchant_Super_user' &&
        results.data.listOrderShipments.items.length === 0
      ) {
        console.log('shipmentItems.length', shipmentItems.length);
        setIsOpen(true);
      } else {
        toast({
          title:
            'Clear the Order(s) in Orders to be Accepted/Orders in Progress.',
          description: 'To Track orders: Click on Home/Dashboard',
          status: 'error',
        });
      }
    } else {
      setIsOpen(true);
    }
  };

  const updateShippingOrder = async (updateStoreObj) => {
    try {
      const res = await graphql(
        graphqlOperation(isShippingPauseOrder, {
          input: updateStoreObj,
        }),
      );
      if (res?.data?.updateStore?.isShippingPaused) {
        toast({
          title: 'Success',
          description: 'Successfully paused the shipping orders',
        });
      } else {
        toast({
          title: 'Success',
          description: 'Successfully resumed the orders',
        });
      }

      if (res?.data) {
        updateServiceableStores();
      }
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Something went wrong',
        status: 'error',
        isClosable: true,
        duration: 5000,
      });
    }
  };

  const updatePickupOrder = async (updateStoreObj) => {
    try {
      const res = await graphql(
        graphqlOperation(isPickupPauseOrder, {
          input: updateStoreObj,
        }),
      );
      if (res?.data?.updateStore?.isPickupPaused) {
        toast({
          title: 'Success',
          description: 'Successfully paused the pickup orders',
        });
      } else {
        toast({
          title: 'Success',
          description: 'Successfully resumed the orders',
        });
      }

      if (res?.data) {
        updateServiceableStores();
      }
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Something went wrong',
        status: 'error',
        isClosable: true,
        duration: 5000,
      });
    }
  };

  useEffect(() => {
    const showpausedstorespopup = localStorage.getItem('showpausedstorespopup');
    if (!showpausedstorespopup) {
      setWelcomeOpen(true);
      localStorage.setItem('showpausedstorespopup', 1);
    }
  }, []);

  return (
    <Box>
      <Flex minH="60px" align="center">
        <MobileSidebar />

        <Flex
          flex={{ base: 1 }}
          justify={{ base: 'center', md: 'start' }}
          alignItems="baseline"
        >
          <Tooltip
            hasArrow
            label="Home / Dashboard"
            bg="brand.red"
            color="White"
          >
            <Button
              width="120px"
              variant="link"
              onClick={() => {
                navigate('/');
              }}
            >
              <Image src={require('../../../assets/logo/small.svg')} />
            </Button>
          </Tooltip>
          <Flex
            ml={5}
            fontWeight="700"
            fontSize="md"
            textTransform="uppercase"
            alignItems="center"
          >
            <Divider
              display={{ base: 'none', md: 'flex' }}
              orientation="vertical"
              width="3px"
              borderColor="#717476"
              height="30px"
              mr={4}
            />
            <Text
              alignSelf="center"
              display={{ base: 'none', md: 'flex' }}
              className="pageTitle"
            >
              {pageName}
            </Text>
          </Flex>
        </Flex>
        <Stack
          pr="2"
          flex={{ base: 1, md: 0 }}
          justify="flex-end"
          direction="row"
          spacing={6}
          alignItems="center"
        >
          {/* <Flex display={{ base: 'none', md: 'flex' }}>
            <InputGroup>
              <Input
                variant="outline"
                type="text"
                bg="#fff"
                // variant="filled"
                width="260px"
                placeholder="search"
                color={colorMode === 'light' ? 'black' : 'white'}
              />
              <InputRightElement
                pointerEvents="none"
                children={<SearchIcon color="#D6D7E3" />}
              />
            </InputGroup>
          </Flex> */}
          {serviceableStores?.items?.length > 0 && (
            <Flex display={{ base: 'none', md: 'flex' }}>
              <Menu closeOnSelect={false}>
                {customActions.actions['pause-orders'] === true ? (
                  <MenuButton
                    border="none"
                    as={Button}
                    bg={
                      storesNotServiceable?.length > 0 ? '#b72618' : '#cfcccc'
                    }
                  >
                    Pause Orders
                  </MenuButton>
                ) : null}
                <MenuList>
                  <MenuGroup>
                    <Table variant="simple">
                      <Thead>
                        <Tr fontSize="xl">
                          <Th>Store Name</Th>
                          <Th>
                            <Box float="left" paddingRight="3px">
                              <Image
                                src={require('../../../assets/icons/delivery_icon.svg')}
                                title="Delivery"
                              />
                            </Box>
                          </Th>
                          <VisuallyHidden>
                            <Th>
                              <Box float="left" paddingRight="3px">
                                <Image
                                  src={require('../../../assets/icons/shipping_icon.svg')}
                                  title="Shipping"
                                />
                              </Box>
                            </Th>
                          </VisuallyHidden>
                          <Th>
                            <Box float="left" paddingRight="1px">
                              <Image
                                src={require('../../../assets/icons/pickup_icon.svg')}
                                title="Pickup"
                              />
                            </Box>
                          </Th>
                        </Tr>
                      </Thead>
                      {serviceableStores?.items?.map((servisableStore) => (
                        <Tbody>
                          <Tr>
                            <Td>{servisableStore.storeName}</Td>
                            <Td>
                              <Switch
                                id="servisableStore.id"
                                colorScheme="red"
                                isChecked={servisableStore.isDeliveryPaused}
                                onChange={(event) => {
                                  updateStore({
                                    id: servisableStore.id,
                                    isDeliveryPaused: event.target.checked,
                                    storeName: servisableStore.storeName,
                                  });
                                }}
                              />
                            </Td>
                            <VisuallyHidden>
                              <Td>
                                <Switch
                                  id="servisableStore.id"
                                  colorScheme="red"
                                  isChecked={servisableStore.isShippingPaused}
                                  onChange={(event) => {
                                    updateShippingOrder({
                                      id: servisableStore.id,
                                      isShippingPaused: event.target.checked,
                                      storeName: servisableStore.storeName,
                                    });
                                  }}
                                />
                              </Td>
                            </VisuallyHidden>
                            <Td>
                              <Switch
                                id="servisableStore.id"
                                colorScheme="red"
                                isChecked={servisableStore.isPickupPaused}
                                onChange={(event) => {
                                  updatePickupOrder({
                                    id: servisableStore.id,
                                    isPickupPaused: event.target.checked,
                                    storeName: servisableStore.storeName,
                                  });
                                }}
                              />
                            </Td>
                          </Tr>
                        </Tbody>
                      ))}
                    </Table>
                  </MenuGroup>
                </MenuList>
              </Menu>
            </Flex>
          )}
          <Flex alignItems="center" display={{ base: 'none', md: 'flex' }}>
            <Tooltip
              hasArrow
              label="Notifications"
              bg="brand.red"
              color="White"
            >
              <BellIcon color="#717476" fontSize="20px" />
            </Tooltip>
          </Flex>
          <Tooltip
            hasArrow
            label={colorMode === 'light' ? 'Dark Mode' : 'Light Mode'}
            bg="brand.red"
            color="White"
          >
            <IconButton
              size="md"
              alignItems="center"
              fontSize="xl"
              aria-label="Switch to mode"
              variant="ghost"
              color="current"
              ml={{ base: '0', md: '3' }}
              disabled={!customActions?.actions['enable-dark-mode']}
              onClick={toggleColorMode}
              icon={colorMode === 'light' ? <FaMoon /> : <FaSun />}
            />
          </Tooltip>
          <Flex alignItems="center" display={{ base: 'none', md: 'flex' }}>
            <Text noOfLines={1} isTruncated title={userName}>
              {userName}
            </Text>
          </Flex>

          <Menu>
            <Tooltip
              hasArrow
              label="Profile / Settings"
              bg="brand.red"
              color="White"
            >
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
                width="50px"
                height="50px"
              >
                <Avatar
                  name={userName}
                  bg="red.500"
                  src={
                    profileImage || require('../../../assets/defaultUser.png')
                  }
                />
              </MenuButton>
            </Tooltip>

            <MenuList {...menuListStylesProps} w="200px">
              <TriangleUpIcon
                position="absolute"
                width="25px"
                height="25px"
                left="155px"
                top="-19px"
                color="brand.red"
              />
              <MenuItem
                _hover={{ bg: 'brand.red' }}
                _focus={{ bg: 'brand.red' }}
                onClick={() => {
                  navigate('/userprofile/');
                }}
                icon={<ImUser fontSize="18px" />}
              >
                My Profile
              </MenuItem>
              <MenuItem
                _hover={{ bg: 'brand.red' }}
                _focus={{ bg: 'brand.red' }}
                onClick={() => {
                  changePasswordConfirmOpenFunc(true);
                  // navigate('/changePassword/');
                }}
                icon={<IoMdUnlock fontSize="18px" />}
              >
                Change Password
              </MenuItem>
              {(customActions?.actions['view-merchant-profile'] ||
                customActions?.actions['edit-merchant-profile']) && (
                <MenuItem
                  _hover={{ bg: 'brand.red' }}
                  _focus={{ bg: 'brand.red' }}
                  onClick={() => {
                    navigate('/merchantprofile/');
                  }}
                  icon={<ImUserTie fontSize="18px" />}
                >
                  Merchant Profile
                </MenuItem>
              )}
              <MenuItem
                _hover={{ bg: 'brand.red' }}
                _focus={{ bg: 'brand.red' }}
                onClick={() => {
                  if (user.userRole === 'Merchant_Super_user') {
                    handleDeleteAccount();
                  } else {
                    console.log('abvgf');
                    setIsOpen(true);
                  }
                }}
                icon={<MdDelete fontSize="16px" />}
              >
                Delete My Account
              </MenuItem>
              <MenuItem
                _hover={{ bg: 'brand.red' }}
                icon={<MdSettings fontSize="18px" />}
              >
                Settings
              </MenuItem>
              <MenuItem
                icon={<RiLogoutBoxRFill fontSize="18px" />}
                _hover={{ bg: 'brand.red' }}
                onClick={async () => {
                  await Auth.signOut();
                  logout(() => {
                    navigate('/login');
                    localStorage.clear();
                    sessionStorage.clear();
                  });
                }}
              >
                Sign out
              </MenuItem>
            </MenuList>
          </Menu>
        </Stack>
      </Flex>

      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        size="lg"
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader color="white" fontSize="lg" bg="brand.red">
            Confirmation
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>Are you sure you want to delete your account?</ModalBody>
          <ModalFooter>
            <Button
              color="brand.red"
              borderColor="brand.red"
              variant="cancel-button"
              onClick={() => {
                navigate('/');
                setIsOpen(false);
              }}
            >
              Cancel
            </Button>

            <Button
              ml={5}
              onClick={() => {
                deleteUser();
              }}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <ChangePasswordView
        onChangePasswordClose={onChangePasswordClose}
        isOpen={changePasswordOpen}
      />
      {storesNotServiceable?.length > 0 && location.pathname === '/' && (
        <PausedStoresInfoModal
          isOpen={welcomeOpen}
          setWelcomeOpen={setWelcomeOpen}
          storesNotServiceable={storesNotServiceable}
        />
      )}
    </Box>
  );
}

const stateMapper = (state) => ({
  pageName: state.page.currentPageTitle,
  profileImage: state.auth.profileImage,
  userName: state.auth?.user?.firstName || '',
  user: state.auth.user,
  serviceableStores: state.auth?.serviceableStores,
  accessModules: state.auth.accessModules,
});

const dispatchMapper = (dispatch) => ({
  updateServiceableStores: dispatch.auth.updateServiceableStores,
});
export default connect(stateMapper, dispatchMapper)(TopbarWithoutRedux);
